import { Trans, useTranslation } from '@egw/i18n'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { type FC } from 'react'
import { SubmitInvestmentWireOutputErrorType } from '@egw/api'
import { ClientServicesLink } from '../client-services-link/client-services-link'

interface ClientServiceErrorProps {
  errorType?: SubmitInvestmentWireOutputErrorType
}

export const ClientServiceError: FC<ClientServiceErrorProps> = ({ errorType }) => {
  const { t } = useTranslation('features-transfer')

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-6">
        <ExclamationCircleIcon className="h-11 w-11 stroke-[1px] text-text-error" />
        <div className="text-body text-sm font-light">
          <Trans
            t={t}
            i18nKey={
              errorType !== SubmitInvestmentWireOutputErrorType.LIQUIDATION_NOT_ALLOWED
                ? 'error.wire_transfer_modal_content'
                : 'error.wire_transfer_modal_liquidation_not_allowed'
            }
            components={{ 1: <br /> }}
          />
          :
        </div>
      </div>
      <ClientServicesLink />
    </div>
  )
}
